import {CrossSellType} from "../../definitions/types";
import {mapper} from "../../utils/helpers";
import {CrossSellModel} from "../domain/crossSellModel";

export class BundleModel {
    private readonly _crossSells: CrossSellModel[];

    /**
     * @constructor
     * @param crossSells - The cross-sells for the bundle model
     * @description Creates a new instance of the model
     */
    constructor(crossSells: CrossSellType[]) {
        this._crossSells = crossSells.map(crossSell => mapper.crossSellToModel(crossSell));
    }

    /**
     * @method crossSells
     * @description Gets the cross-sells for the bundle model
     * @returns {CrossSellModel[]}
     */
    public get crossSells(): CrossSellModel[] {
        return this._crossSells;
    }
}